/* eslint-disable no-shadow */
const state = {
	segmentsData: []
}

const getters = {
	getSegmentsData: state => state.segmentsData
}

const mutations = {
	setSegmentsDataMutation: (state, payload) => {
		state.segmentsData = JSON.stringify(payload)
	}
}

const actions = {
	setSegmentsData: ({ commit }, payload) => {
		commit('setSegmentsDataMutation', payload)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
